import React from 'react';
import { motion } from 'framer-motion';
import { Mic, Calendar, ExternalLink, Users, Award } from 'lucide-react';
import { speakingEngagements } from '../data/siteData';

const Speaking = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };

  const hasEngagements = speakingEngagements && speakingEngagements.length > 0;

  const getRoleIcon = (role) => {
    switch (role) {
      case 'Judge':
        return Award;
      case 'Panelist':
        return Users;
      default:
        return Mic;
    }
  };

  return (
    <section id="speaking" className="speaking-section">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h1>Speaking & Professional Community</h1>
          <p>Talks, presentations, mentoring, and community involvement</p>
        </motion.div>

        {hasEngagements ? (
          <motion.div
            className="speaking-grid"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {speakingEngagements.map((engagement) => {
              const RoleIcon = getRoleIcon(engagement.role);
              return (
                <motion.div
                  key={engagement.id}
                  className="speaking-card"
                  variants={itemVariants}
                  whileHover={{ y: -5 }}
                >
                  <div className="speaking-header">
                    <div className="speaking-role">
                      <RoleIcon size={18} />
                      <span>{engagement.role}</span>
                    </div>
                    <span className="speaking-date">
                      <Calendar size={14} />
                      {engagement.date}
                    </span>
                  </div>
                  <h2>{engagement.title}</h2>
                  <p className="speaking-event">{engagement.event}</p>
                  {engagement.description && (
                    <p className="speaking-description">{engagement.description}</p>
                  )}
                  {engagement.url && (
                    <a 
                      href={engagement.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="speaking-link"
                    >
                      View Details <ExternalLink size={14} />
                    </a>
                  )}
                </motion.div>
              );
            })}
          </motion.div>
        ) : (
          <motion.div
            className="empty-state"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <Mic size={48} className="empty-state-icon" />
            <p className="empty-state-text">Speaking engagements coming soon</p>
            <p className="empty-state-subtext">Talks, panels, and community events will appear here.</p>
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default Speaking;
